import { render, staticRenderFns } from "./defaultTextUnitCustom.vue?vue&type=template&id=f228f68e"
import script from "./defaultTextUnitCustom.vue?vue&type=script&lang=js"
export * from "./defaultTextUnitCustom.vue?vue&type=script&lang=js"
import style0 from "./defaultTextUnitCustom.vue?vue&type=style&index=0&id=f228f68e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports